import styled from "styled-components";

export const StyledAlert = styled.div`
  .title {
    padding: 4.8rem 3.2rem;
    width: 27.9rem;
    font: var(--body-large-400);
    color: var(--text-gray-strong);
    text-align: center;
    display: flex;
    flex-flow: column nowrap;
    gap: 0.2rem;
    .sub-message {
      font: var(--body-small-400);
      color: var(--text-gray-4);
    }
  }

  .footer-wrap {
    padding: 1.2rem;
    display: flex;
    flex-flow: row nowrap;
    gap: 0.8rem;
    justify-content: end;
  }
`;
